import { FileItemWide as e } from "./file-item-wide.mjs";
import { FileItemCompact as t } from "./file-item-compact.mjs";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/file-item/file-item.tsx
var r = (r) => {
	let { wide: i } = r;
	return n(i ? e : t, { ...r });
};
//#endregion
export { r as FileItem };
